/**
 * Color conversion utilities shared across panels.
 */

/**
 * Convert RGB [0-255, 0-255, 0-255] to hex color #RRGGBB
 */
export function rgbToHex(rgb: [number, number, number]): string {
  const r = Math.round(rgb[0]).toString(16).padStart(2, '0');
  const g = Math.round(rgb[1]).toString(16).padStart(2, '0');
  const b = Math.round(rgb[2]).toString(16).padStart(2, '0');
  return `#${r}${g}${b}`;
}

/**
 * Convert hex color #RRGGBB to RGB [0-255, 0-255, 0-255]
 */
export function hexToRgb(hex: string): [number, number, number] {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    return [0, 0, 0];
  }
  return [
    parseInt(result[1] ?? '0', 16),
    parseInt(result[2] ?? '0', 16),
    parseInt(result[3] ?? '0', 16),
  ];
}
